import { render, staticRenderFns } from "./TopFiveTurnover.vue?vue&type=template&id=58041566&"
import script from "./TopFiveTurnover.vue?vue&type=script&lang=js&"
export * from "./TopFiveTurnover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports